import type { StoreApi } from 'zustand'
import type { Shape } from './store'

import { createContext } from 'react'

import { store } from './store'

type ApplicationStore = StoreApi<Shape>
export const ApplicationContext = createContext<ApplicationStore | null>(null)

type ApplicationProviderProps = {
	children: React.ReactNode
} & Partial<Shape>
export const ApplicationProvider = ({
	children,
	...initialState
}: ApplicationProviderProps) => (
	<ApplicationContext value={store}>{children}</ApplicationContext>
)
